const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  fillHeight: {
    boxSizing: 'border-box',
    height: 'calc(100vh - 88px)',
    minHeight: 0,
    pb: 2,
  },
};

export default styles;
